'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SelectPeople = require('./SelectPeople.scss');

var _SelectPeople2 = _interopRequireDefault(_SelectPeople);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SelectPeople: {
    displayName: 'SelectPeople'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/FormElements/SelectPeople.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var SelectPeople = _wrapComponent('SelectPeople')((_dec = (0, _reactCssModules2.default)(_SelectPeople2.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SelectPeople, _Component);

  function SelectPeople() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SelectPeople);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectPeople.__proto__ || (0, _getPrototypeOf2.default)(SelectPeople)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          fieldName = _this$props.fieldName;
      var value = e.target.value;

      onChange(fieldName, 'SelectPeople', isNaN(value) ? value : parseInt(value, 10));
      e.target.blur();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // constructor(props) {
  //   super(props);
  //   if (props.default) {
  //     const selectedOption = props.options.filter((opt)=> {
  //       return opt.value === props.default;
  //     });
  //     this.state = {
  //       text: selectedOption[0].text,
  //       selected: selectedOption[0].value,
  //     };
  //   } else {
  //     this.state = {
  //       text: props.placeholder,
  //     };
  //   }
  // }

  (0, _createClass3.default)(SelectPeople, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          homeStyle = _props.homeStyle,
          noIcon = _props.noIcon,
          error = _props.error,
          plusEnabled = _props.plusEnabled;

      var personIcon = require('theme/images/icons/person-dark.png');
      var personOrangeIcon = require('theme/images/icons/person-orange.png');
      var options = this.props.options;
      if (options.length > 0 && options.length < 8 && plusEnabled) {
        options = [].concat((0, _toConsumableArray3.default)(options), [options[options.length - 1] + 1 + '+']);
      }
      return _react3.default.createElement(
        'div',
        { styleName: homeStyle ? 'dropdown-home' : 'dropdown', style: error ? { border: '1px solid #d0021b' } : null },
        _react3.default.createElement(
          'span',
          { styleName: homeStyle ? 'text-left-home' : 'text-left' },
          value
        ),
        homeStyle && !noIcon && _react3.default.createElement('div', { styleName: 'icon-home', style: { 'background': 'url(' + personOrangeIcon + ') no-repeat 50% 50%', 'backgroundSize': 'contain' } }),
        !homeStyle && !noIcon && _react3.default.createElement('div', { styleName: 'icon', style: { 'background': 'url(' + personIcon + ') no-repeat 50% 50%', 'backgroundSize': 'contain' } }),
        _react3.default.createElement(
          'select',
          { 'data-tmt': 'select-qty', onChange: this.onChange, value: value },
          options.map(function (option) {
            return _react3.default.createElement(
              'option',
              { key: option, value: option },
              option
            );
          })
        ),
        _react3.default.createElement('div', { styleName: homeStyle ? 'dropdown-arrow-home' : 'dropdown-arrow' })
      );
    }
  }]);
  return SelectPeople;
}(_react2.Component), _class2.propTypes = {
  options: _react2.PropTypes.array,
  placeholder: _react2.PropTypes.string,
  value: _react2.PropTypes.number,
  onChange: _react2.PropTypes.func,
  fieldName: _react2.PropTypes.string,
  homeStyle: _react2.PropTypes.bool,
  error: _react2.PropTypes.bool,
  noIcon: _react2.PropTypes.bool,
  plusEnabled: _react2.PropTypes.bool
}, _class2.defaultProps = {
  placeholder: 'Please select',
  options: [1, 2, 3, 4, 5, 6, 7, 8],
  homeStyle: false,
  error: false
}, _temp2)) || _class));

exports.default = SelectPeople;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/FormElements/SelectPeople.js
// module id = 97
// module chunks = 0 4 5 6 10 29